<template>
    <div
        ref="spinnerRef"
        class="spinner-wrapper"
        :class="{ 'bic-content--menu-gutter': inMapFloatingModal }"
    >
        <button title="Voltar"
                v-if="currentPropertyId && propertiesSubdivision.length > 1"
                @click="goBack"
                style="border-radius: 50%; display: flex; justify-content: center; align-items: center; padding: 8px;">
            <ArrowLeftOutlined style="font-size: 10px;" />
        </button>
        <a-spin :spinning="spinning || loadingPropertyData">
            <template #indicator>
                <div class="full-screen-spinner">
                    <a-spin tip="Carregando..." size="large" />
                </div>
            </template>
            <SelectionProperties
                v-if="propertiesSubdivision.length > 1 && !currentPropertyId"
                :properties="propertiesSubdivision"
                @select-property="selectProperty"
            />

            <PropertyData
                v-if="currentPropertyId && propertyData && !loadingPropertyData"
                :data="propertyData"
                :subdivision-property-id="props.subdivisionPropertyId"
            />
        </a-spin>
    </div>
</template>


<script setup>
import { defineProps, nextTick, onMounted, ref } from 'vue'
import SelectionProperties from "./SelectionProperties.vue";
import PropertyData from "./PropertyData.vue";
import {ArrowLeftOutlined} from "@ant-design/icons-vue";
import {notification} from 'ant-design-vue';
import { openNotification } from '../../../../../utils/utilities.js';
const props = defineProps({
    registration: [String, Number],
    searchSelect: Boolean,
    subdivisionPropertyId: Number,
})

const emit = defineEmits(['selectProperty'])
const spinnerRef = ref(null)
/** BIC renderizada dentro de #map-popups (popup do mapa na Home): recuo à esquerda = largura do botão do menu. */
const inMapFloatingModal = ref(false)
const loadingPropertyData = ref(false)
const goBack = () => {
    currentPropertyId.value = null
    propertyData.value = null
}

const spinning = ref(false)
const currentPropertyId = ref(null)

const propertyData = ref(null)
const propertiesSubdivision = ref([])

const normalizePropertyId = (id) => {
    if (id == null || id === '') return null
    const normalized = Number(id)
    return Number.isFinite(normalized) ? normalized : id
}

const routes = {
    propertiesSubdivision: `/api/map-actions/bic/subdivision/properties/get-by-property`
}

const getPropertiesSubdivision = async (idProperty) => {
    try {
        spinning.value = true
        propertiesSubdivision.value = (await window.axios.get(`${routes.propertiesSubdivision}/${idProperty}`)).data.data
        spinning.value = false
    } catch (error) {
        spinning.value = false
        openNotification('error', error.message)
    }
}

const getPropertyData = async (idProperty) => {
    try {
        spinning.value = true
        propertyData.value = (await window.axios.get(`/api/map-actions/bic/property-data/${idProperty}`)).data.data
        spinning.value = false
    } catch (error) {
        spinning.value = false
        openNotification('error', error.response.data.message)
    }
}

const loadPropertyData = async (idProperty) => {
    const normalizedId = normalizePropertyId(idProperty)
    if (!normalizedId) {
        propertyData.value = null
        return
    }
    loadingPropertyData.value = true
    await getPropertyData(normalizedId)
    loadingPropertyData.value = false
}

const selectProperty = (id) => {
    const normalizedId = normalizePropertyId(id)
    emit('selectProperty', normalizedId)
}

const loadBicData = async (id) => {
    const registrationId = id || normalizePropertyId(props.registration)
    await getPropertiesSubdivision(registrationId)

    if (props.searchSelect) {
        currentPropertyId.value = registrationId
    } else {
        currentPropertyId.value = null

        if (propertiesSubdivision.value.length === 1) {
            currentPropertyId.value = normalizePropertyId(propertiesSubdivision.value[0].id)
        }
    }

    if (currentPropertyId.value) {
        await loadPropertyData(currentPropertyId.value)
    }
}

onMounted(async () => {
    await nextTick()
    inMapFloatingModal.value = !!spinnerRef.value?.closest?.('#map-popups')

    loadBicData()
})

</script>

<style scoped>
:deep(.ant-tabs-tab) {
    padding: 0 5px;
    max-width: 105px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

:deep(.ant-tabs-tab:hover) {
    background-color: transparent !important;
    border-color: transparent !important;
}

:deep(.ant-tabs-nav) {
    flex-wrap: wrap !important;
}

.spinner-wrapper {
    position: relative;
    min-height: 300px;
}

.bic-content--menu-gutter {
    box-sizing: border-box;
    /* largura do botão do menu + um pouco a mais de respiro */
    --bic-menu-left-inset: calc(var(--home-map-icon-size, 32px) + 10px);
    margin-left: var(--bic-menu-left-inset);
    width: calc(100% - var(--bic-menu-left-inset));
}

.full-screen-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 10;
}
</style>
